/**
 * 项目配置文件，在打包和业务代码中都有使用
 */
const env = process.env.PEANUT_ENV || 'production'    // env:development,production,test,stable

module.exports = {
    name: 'EASY',
    env,
    dev: {
        port: '5100',
    },
    ossPrefix: 'https://file.pjinnovation.com/',
    dhDomain: {
        development: 'http://localhost:9701',
        test: 'http://peanut.test.sesameitech.com',
        production: 'https://www.peanutjob.com',
    },
    EASYDomain: {
        development: 'http://localhost:9604',
        test: 'http://peanut.manager.test.sesameitech.com',
        production: 'https://www.pjinnovation.com',
    },
    zealCNEASYDomain: {
        development: 'http://peanut.manager.test.sesameitech.com',
        test: 'https://peanut.manager.test.sesameitech.com',
        production: 'https://www.pjinnovation.com',
    },
    maidIslandDomain: {
        development: 'http://localhost:11103',
        test: 'http://peanut.test.sesameitech.com',
        production: 'https://www.maidisland.com',
    },
}
